// extracted by mini-css-extract-plugin
export default {"page":"LX-z","cartModal":"MX-z","checkout":"NX-z","placeholder":"OX-z","account":"PX-z"};